import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import fsccardfront from "../assets/fsccardfront.png";

const Home = () => {
  const sliderImages = [
    "https://www.forceid.in/wp-content/uploads/2019/07/custom-pvc-cards.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOHOojK1VggVKQp2x5oO-PLBIR0MP2RTyybg&s",
    "https://himachalwatcher.com/wp-content/uploads/2018/06/digital-ration-card-holders-in-Himachal-pRadesh.jpg",
  ];

  const features = [
    {
      title: "Easy FSC Data Fetch",
      image: fsccardfront,
      // "https://images-na.ssl-images-amazon.com/images/I/71YB1d+XSqL._AC_SL1500_.jpg",
      description: "Quickly fetch and preview user data using FSC number.",
    },
    {
      title: "High Quality PVC Cards",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKfM4DUKDH32tTIw0WpTSYVWKGgGBARmgAwA&s",
      description:
        "Durable, waterproof, and long-lasting cards with professional finish.",
    },

    {
      title: "Smart Download System",
      image: "https://i.cdn.newsbytesapp.com/images/l59320230227120921.png",
      description:
        "Secure, credits-based download and image generation system.",
    },
  ];

  return (
    <div className="container-fluid p-0">
      {/* Hero Carousel */}
      {/* <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {sliderImages.map((src, i) => (
            <div className={`carousel-item ${i === 0 ? "active" : ""}`} key={i}>
              <img
                src={src}
                className="d-block w-100"
                style={{ height: "400px", objectFit: "cover" }}
                alt={`Slide ${i + 1}`}
              />
            </div>
          ))}
        </div>
      </div> */}
      <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner w-75 d-flex justify-content-center mt-5">
          {sliderImages.map((src, i) => (
            <div className={`carousel-item ${i === 0 ? "active" : ""}`} key={i}>
              <img
                src={src}
                className="d-block"
                style={{ height: "400px", objectFit: "cover" }}
                alt={`Slide ${i + 1}`}
              />
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* Welcome Section */}
      <section
        className="text-white text-center d-flex align-items-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1581090700227-1e8e8f3c1c3d?auto=format&fit=crop&w=1600&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          position: "relative",
        }}
      >
        <div
          className="container"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: "2rem",
            borderRadius: "10px",
          }}
        >
          <h1 className="display-4 fw-bold">PVC Ration Card Printing Portal</h1>
          <p className="lead">
            Print beautiful and secure PVC Ration Cards with ease using FSC
            data.
          </p>
          <Link to="/login" className="btn btn-warning btn-lg mt-3 shadow">
            Start Printing
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="container py-5">
        <div className="row text-center">
          {features.map((feature, i) => (
            <div className="col-md-4 mb-4" key={i}>
              <div className="card h-100 shadow-sm border-0">
                <img
                  src={feature.image}
                  className="card-img-top"
                  alt={feature.title}
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h5 className="card-title text-primary">{feature.title}</h5>
                  <p className="card-text text-muted">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why PVC Card Section */}
      <section className="bg-primary text-white py-5">
        <div className="container text-center">
          <h2 className="mb-4">Why Choose PVC Ration Cards?</h2>
          <p className="lead">
            PVC cards are waterproof, tamper-proof, and long-lasting. They offer
            a professional look and are easy to carry. Ideal for
            government-issued IDs like ration cards.
          </p>
        </div>
      </section>

      {/* Become an Agent Section */}
      <section className="container py-5 text-center">
        <h2 className="text-dark mb-4">Become an Authorized Agent</h2>
        <p className="text-muted mb-4">
          Join our network and start offering PVC Ration Card printing services
          in your area. Earn with every card you print!
        </p>
        <Link to="/contact" className="btn btn-outline-primary btn-lg">
          Register as Agent
        </Link>
      </section>

      {/* Footer */}
    </div>
  );
};

export default Home;
